import React from "react";
import { makeStyles, Typography, List, ListItem } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  headLine: {
    color: "#0c3c5c",
    textAlign: "center",
    fontSize: 30,
    fontWeight: "bold",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    color: "#0c3c5c",
    textAlign: "left",
    fontSize: 20,
    fontWeight: "bold",
    marginLeft: "5vh",
    marginRight: "10vh",
    marginTop: theme.spacing(2),
  },
  bulletList: {
    listStyleType: "disc",
    marginLeft: "3vh",
    listStylePosition: "inside",
  },
  bulletItem: {
    display: "list-item",
    marginBottom: theme.spacing(1),
  },
}));

export default function SwimJourney() {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.headLine}>
        Program Policies & Student Rules
      </Typography>

      <Typography className={classes.subTitle}>1. Health & Safety</Typography>
      <List className={classes.bulletList}>
        <ListItem className={classes.bulletItem}>
          Students must declare any medical condition before registration. FL
          Swimming School will not be responsible for accidents caused by
          undisclosed health issues.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          All sports activities involve risks. Students and parents agree to
          participate at their own risk.
        </ListItem>
      </List>

      <Typography className={classes.subTitle}>2. Attendance</Typography>
      <List className={classes.bulletList}>
        <ListItem className={classes.bulletItem}>
          Students must arrive on time for each class.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Full attendance is required. Absence must be reported in advance by
          phone or in person.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Each student is allowed one make-up class per session if notice is
          given at least 24 hours in advance.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Make-up class schedules are arranged by staff. If a rescheduled
          make-up class needs to be changed again, prior notification is
          required.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Make-up classes or absences cannot be converted into refunds.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          If classes are cancelled by FL Swimming School due to pool facility
          issues (e.g., water temperature or water quality not meeting
          standards), the cancelled class will be automatically rescheduled.
          Students will not lose that class, and no additional make-up request
          is required.
        </ListItem>
      </List>

      <Typography className={classes.subTitle}>
        3. Equipment & Conduct
      </Typography>
      <List className={classes.bulletList}>
        <ListItem className={classes.bulletItem}>
          Students must bring swimsuit, goggles, swim cap, and towel.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Proper swim attire is required to enter the pool.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Students must respect instructors and staff. Violation of rules may
          result in disqualification.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          The instructor has full authority over students attending class. Other
          children must be supervised by parents or guardians.
        </ListItem>
      </List>

      <Typography className={classes.subTitle}>4. Tuition & Payment</Typography>
      <List className={classes.bulletList}>
        <ListItem className={classes.bulletItem}>
          Tuition must be paid in full by the first class.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Once the session begins, no refunds will be issued.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          If students or parents unilaterally decide to stop attending classes,
          no refund will be issued. All payments are final and non-refundable.
        </ListItem>
      </List>

      <Typography className={classes.subTitle}>5. Safety Rules</Typography>
      <List className={classes.bulletList}>
        <ListItem className={classes.bulletItem}>
          Shower before entering the pool.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Running, diving, or jumping without supervision is prohibited.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Children not in class must be supervised by parents/guardians.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          No pushing, rough play, or dangerous behavior in or around the pool.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Diving and jumping are only allowed under instructor supervision.
        </ListItem>
        <ListItem className={classes.bulletItem}>
          Children must be accompanied by a parent or guardian when using the
          bathroom or changing rooms.
        </ListItem>
      </List>

      <Typography className={classes.subTitle}>6. Special Notes</Typography>
      <List className={classes.bulletList}>
        <ListItem className={classes.bulletItem}>
          FL Swimming School reserves the right to alter terms. In case of
          dispute, the decision of FL Swimming School is final.
        </ListItem>
      </List>
    </div>
  );
}
